<template>
  <div class="dropper">
    <div class="d_l">
      <span>滴灌</span>
      &nbsp;
      <span class="img">
        <img src="./../../assets/images/dropper.png" alt="" srcset="" />
      </span>
    </div>
    <div class="d_r">
      <div class="time">
        <div class="item" v-for="(item,index) in data" :key="`${item.week}_${index}`">
          <div class="date" v-if="item.sDate">
            {{ item.sDate.replace('-', '/') }}
          </div>
          <div class="week" v-if="item.week">{{ item.week }}</div>
        </div>
      </div>
      <div id="chart_area"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    return {}
  },

  mounted () {
    console.error('123:', this.data)
    this.renderCharts()
  },

  methods: {
    renderCharts () {
      this.chartsBody = echarts.init(document.getElementById('chart_area'))
      this.chartsBody.showLoading()
      const option = {
        tooltip: {
          show: false,
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          top: '25px',
        },
        xAxis: [
          {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            show: false,
          },
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '90%',
            itemStyle: {
              color: '#2855BB',
            },
            label: {
              show: true,
              position: 'top',
              formatter: (v) => {
                let duration = this.data[v.dataIndex].duration

                console.log("duration:", duration);

                duration = duration.replace('h', '-')
                duration = duration.replace('m', '-')

                const arr = duration.split('-').filter((o) => o)

                return duration ? `${arr[0]}h\n${arr[1] || 0}m` : ``
              },
            },
            data: this.data.map((o) => o.mSecond),
          },
        ],
      }

      this.chartsBody.setOption(option)
      this.chartsBody.hideLoading()
    },
  },
}
</script>

<style lang="scss" scoped>
.dropper {
  display: flex;
  padding: 10px;
  padding-bottom: 0;
  border-bottom: 1px solid #999;
  margin-bottom: 20px;

  .d_l {
    font-size: 14px;
    width: 60px;
    margin: auto;
    font-weight: bold;
  }

  .img {
    display: inline-block;
    vertical-align: top;
    width: 8px;
    height: 14px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .d_r {
    width: 100%;

    .time {
      display: flex;
      font-size: 12px;
      margin-bottom: 5px;

      .item {
        flex: 1;
        text-align: center;
      }
    }

    #chart_area {
      width: 100%;
      height: 150px;
    }
  }
}
</style>
